var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cj" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.winnerList.length > 0
        ? _c("van-notice-bar", {
            staticClass: "winnerList",
            attrs: { "left-icon": "volume-o", text: _vm.winnerText }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cell" },
        _vm._l(_vm.AwardList, function(item, index) {
          return _c("div", { key: index }, [
            index == 4 && _vm.status == 2
              ? _c("div", { staticClass: "gray" }, [
                  _c(
                    "div",
                    {
                      staticClass: "CellItem",
                      class:
                        index == 4 || index === _vm.sel
                          ? "YellowBackground"
                          : "WhiteBackground"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "CellItemContent",
                          class:
                            index == 4 || index === _vm.sel ? "Yellow" : "white"
                        },
                        [
                          _c("img", {
                            staticClass: "ItemImage",
                            attrs: { src: require("./images/begin.png") }
                          }),
                          _vm._v(" "),
                          _c("div", {}, [
                            _c("p", { staticClass: "text" }, [
                              _vm._v(_vm._s(item.name))
                            ])
                          ])
                        ]
                      )
                    ]
                  )
                ])
              : _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "CellItem",
                      class:
                        index == 4 || index === _vm.sel
                          ? "YellowBackground"
                          : "WhiteBackground",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.begin(index)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "CellItemContent",
                          class:
                            index == 4 || index === _vm.sel ? "Yellow" : "white"
                        },
                        [
                          index == 0
                            ? _c("img", {
                                staticClass: "ItemImage",
                                attrs: { src: require("./images/j2.png") }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          index == 1 || index == 7
                            ? _c("img", {
                                staticClass: "ItemImage",
                                attrs: { src: require("./images/j2.png") }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          index == 2 || index == 6
                            ? _c("img", {
                                staticClass: "ItemImage",
                                attrs: { src: require("./images/j2.png") }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          index == 3 || index == 5
                            ? _c("img", {
                                staticClass: "ItemImage",
                                attrs: { src: require("./images/j2.png") }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          index == 4 && _vm.status == 0
                            ? _c("img", {
                                staticClass: "ItemImage",
                                attrs: { src: require("./images/begin.png") }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          index == 4 && _vm.status == 1
                            ? _c("img", {
                                staticClass: "ItemImage",
                                attrs: { src: require("./images/begin2.png") }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          index == 4 && _vm.status == 3
                            ? _c("img", {
                                staticClass: "ItemImage",
                                attrs: { src: require("./images/begin3.png") }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          index == 8
                            ? _c("img", {
                                staticClass: "ItemImage",
                                attrs: { src: require("./images/thanks.png") }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {}, [
                            _c("p", { staticClass: "text" }, [
                              _vm._v(_vm._s(item.name))
                            ])
                          ])
                        ]
                      )
                    ]
                  )
                ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.start
        ? _c(
            "van-popup",
            {
              staticClass: "popupClass",
              attrs: { round: "", "close-on-click-overlay": false },
              model: {
                value: _vm.show,
                callback: function($$v) {
                  _vm.show = $$v
                },
                expression: "show"
              }
            },
            [
              _c(
                "div",
                { staticClass: "infoText" },
                [
                  _c("p", [_vm._v(_vm._s(_vm.info) + "\n\t\t\t")]),
                  _vm._v(" "),
                  _vm.showToList
                    ? _c(
                        "van-button",
                        {
                          attrs: { type: "danger", size: "large" },
                          on: { click: _vm.toList }
                        },
                        [_vm._v("查看")]
                      )
                    : _c(
                        "van-button",
                        {
                          attrs: { type: "danger", size: "large" },
                          on: { click: _vm.closePopup }
                        },
                        [_vm._v("确定")]
                      )
                ],
                1
              )
            ]
          )
        : _c(
            "van-popup",
            {
              staticClass: "popupClass",
              attrs: { round: "", "close-on-click-overlay": false },
              model: {
                value: _vm.show,
                callback: function($$v) {
                  _vm.show = $$v
                },
                expression: "show"
              }
            },
            [
              _c("div", { staticClass: "countdown" }, [
                _c("h3", [_vm._v("抽奖倒计时")]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.countdown))])
              ])
            ]
          )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg" }, [
      _c("img", {
        staticClass: "ImageBG",
        attrs: { src: require("./images/bg.jpg"), mode: "widthFix" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-402dad06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-402dad06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/choujiang/choujiang.vue
// module id = null
// module chunks = 